var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "sten",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "poleret granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "poleret diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "poleret andesit",
  "block.minecraft.grass_block": "græsblok",
  "block.minecraft.dirt": "jord",
  "block.minecraft.coarse_dirt": "groft jord",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmoisin nylium",
  "block.minecraft.warped_nylium": "forskruet nylium",
  "block.minecraft.cobblestone": "brosten",
  "block.minecraft.oak_planks": "egeplanker",
  "block.minecraft.spruce_planks": "granplanker",
  "block.minecraft.birch_planks": "birkeplanker",
  "block.minecraft.jungle_planks": "jungleplanker",
  "block.minecraft.acacia_planks": "akacieplanker",
  "block.minecraft.dark_oak_planks": "mørke egeplanker",
  "block.minecraft.crimson_planks": "karmoisinplanker",
  "block.minecraft.warped_planks": "forskruede planker",
  "block.minecraft.oak_sapling": "ungt egetræ",
  "block.minecraft.spruce_sapling": "ungt grantræ",
  "block.minecraft.birch_sapling": "ungt birketræ",
  "block.minecraft.jungle_sapling": "ungt jungletræ",
  "block.minecraft.acacia_sapling": "ungt akacietræ",
  "block.minecraft.dark_oak_sapling": "ungt mørkt egetræ",
  "block.minecraft.bedrock": "grundfjeld",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "rødt sand",
  "block.minecraft.gravel": "grus",
  "block.minecraft.gold_ore": "guldmalm",
  "block.minecraft.iron_ore": "jernmalm",
  "block.minecraft.coal_ore": "kulmalm",
  "block.minecraft.nether_gold_ore": "nether guldmalm",
  "block.minecraft.oak_log": "egestamme",
  "block.minecraft.spruce_log": "granstamme",
  "block.minecraft.birch_log": "birkestamme",
  "block.minecraft.jungle_log": "junglestamme",
  "block.minecraft.acacia_log": "akaciestamme",
  "block.minecraft.dark_oak_log": "mørk egestamme",
  "block.minecraft.crimson_stem": "karmoisinstilk",
  "block.minecraft.warped_stem": "forskruet stilk",
  "block.minecraft.stripped_oak_log": "afbarket egestamme",
  "block.minecraft.stripped_spruce_log": "afbarket granstamme",
  "block.minecraft.stripped_birch_log": "afbarket birkestamme",
  "block.minecraft.stripped_jungle_log": "afbarket junglestamme",
  "block.minecraft.stripped_acacia_log": "afbarket akaciestamme",
  "block.minecraft.stripped_dark_oak_log": "afbarket mørk egestamme",
  "block.minecraft.stripped_crimson_stem": "afbarket karmoisinstilk",
  "block.minecraft.stripped_warped_stem": "afbarket forskruet stilk",
  "block.minecraft.stripped_oak_wood": "afbarket egetræ",
  "block.minecraft.stripped_spruce_wood": "afbarket grantræ",
  "block.minecraft.stripped_birch_wood": "afbarket birketræ",
  "block.minecraft.stripped_jungle_wood": "afbarket jungletræ",
  "block.minecraft.stripped_acacia_wood": "afbarket akacietræ",
  "block.minecraft.stripped_dark_oak_wood": "afbarket mørk egetræ",
  "block.minecraft.stripped_crimson_hyphae": "afbarket karmoisinhyfer",
  "block.minecraft.stripped_warped_hyphae": "afbarkede forskruede hyfer",
  "block.minecraft.oak_wood": "egetræ",
  "block.minecraft.spruce_wood": "grantræ",
  "block.minecraft.birch_wood": "birketræ",
  "block.minecraft.jungle_wood": "jungletræ",
  "block.minecraft.acacia_wood": "akacietræ",
  "block.minecraft.dark_oak_wood": "mørk egetræ",
  "block.minecraft.crimson_hyphae": "karmoisinhyfer",
  "block.minecraft.warped_hyphae": "forskruet hyfer",
  "block.minecraft.oak_leaves": "egeløv",
  "block.minecraft.spruce_leaves": "grannåle",
  "block.minecraft.birch_leaves": "birkeløv",
  "block.minecraft.jungle_leaves": "jungleløv",
  "block.minecraft.acacia_leaves": "akacieløv",
  "block.minecraft.dark_oak_leaves": "mørkt egeløv",
  "block.minecraft.sponge": "svamp",
  "block.minecraft.wet_sponge": "våd svamp",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapis lazuli-malm",
  "block.minecraft.lapis_block": "lapis lazuli-blok",
  "block.minecraft.dispenser": "automat",
  "block.minecraft.sandstone": "sandsten",
  "block.minecraft.chiseled_sandstone": "mejslet sandsten",
  "block.minecraft.cut_sandstone": "skåret sandsten",
  "block.minecraft.note_block": "nodeblok",
  "block.minecraft.powered_rail": "strømspor",
  "block.minecraft.detector_rail": "detektorspor",
  "block.minecraft.sticky_piston": "klistret stempel",
  "block.minecraft.cobweb": "spindelvæv",
  "block.minecraft.grass": "græs",
  "block.minecraft.fern": "bregne",
  "block.minecraft.dead_bush": "død busk",
  "block.minecraft.seagrass": "søgræs",
  "block.minecraft.sea_pickle": "søpølse",
  "block.minecraft.piston": "stempel",
  "block.minecraft.white_wool": "hvid uld",
  "block.minecraft.orange_wool": "orange uld",
  "block.minecraft.magenta_wool": "lyslilla uld",
  "block.minecraft.light_blue_wool": "lyseblå uld",
  "block.minecraft.yellow_wool": "gul uld",
  "block.minecraft.lime_wool": "limegrønt uld",
  "block.minecraft.pink_wool": "lyserød uld",
  "block.minecraft.gray_wool": "grå uld",
  "block.minecraft.light_gray_wool": "lysegrå uld",
  "block.minecraft.cyan_wool": "turkis uld",
  "block.minecraft.purple_wool": "lilla uld",
  "block.minecraft.blue_wool": "blå uld",
  "block.minecraft.brown_wool": "brun uld",
  "block.minecraft.green_wool": "grøn uld",
  "block.minecraft.red_wool": "rød uld",
  "block.minecraft.black_wool": "sort uld",
  "block.minecraft.dandelion": "mælkebøtte",
  "block.minecraft.poppy": "valmue",
  "block.minecraft.blue_orchid": "blå orkidé",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "blå porcelænstjerne",
  "block.minecraft.red_tulip": "rød tulipan",
  "block.minecraft.orange_tulip": "orange tulipan",
  "block.minecraft.white_tulip": "hvid tulipan",
  "block.minecraft.pink_tulip": "lyserød tulipan",
  "block.minecraft.oxeye_daisy": "hvid okseøje",
  "block.minecraft.cornflower": "kornblomst",
  "block.minecraft.lily_of_the_valley": "liljekonval",
  "block.minecraft.wither_rose": "wither rose",
  "block.minecraft.brown_mushroom": "brun svamp",
  "block.minecraft.red_mushroom": "rød svamp",
  "block.minecraft.crimson_fungus": "karmoisinsvamp",
  "block.minecraft.warped_fungus": "forskruet svamp",
  "block.minecraft.crimson_roots": "karmoisinrødder",
  "block.minecraft.warped_roots": "forskruet rødder",
  "block.minecraft.nether_sprouts": "nether spirer",
  "block.minecraft.weeping_vines": "tudende lianer",
  "block.minecraft.twisting_vines": "snoende lianer",
  "block.minecraft.sugar_cane": "sukkerrør",
  "block.minecraft.kelp": "tang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "blok af guld",
  "block.minecraft.iron_block": "blok af jern",
  "block.minecraft.oak_slab": "egeplade",
  "block.minecraft.spruce_slab": "granplade",
  "block.minecraft.birch_slab": "birkeplade",
  "block.minecraft.jungle_slab": "jungleplade",
  "block.minecraft.acacia_slab": "akacieplade",
  "block.minecraft.dark_oak_slab": "mørk egeplade",
  "block.minecraft.crimson_slab": "karmoisinplade",
  "block.minecraft.warped_slab": "forskruet plade",
  "block.minecraft.stone_slab": "stenflise",
  "block.minecraft.smooth_stone_slab": "glat stenflise",
  "block.minecraft.sandstone_slab": "sandstensflise",
  "block.minecraft.cut_sandstone_slab": "skåret sandstensflise",
  "block.minecraft.petrified_oak_slab": "forstenet egeplade",
  "block.minecraft.cobblestone_slab": "brostensflise",
  "block.minecraft.brick_slab": "murstensflise",
  "block.minecraft.stone_brick_slab": "stenmurstensflise",
  "block.minecraft.nether_brick_slab": "nether-murstensflise",
  "block.minecraft.quartz_slab": "kvartsflise",
  "block.minecraft.red_sandstone_slab": "rød sandstensflise",
  "block.minecraft.cut_red_sandstone_slab": "skåret rød sandstensflise",
  "block.minecraft.purpur_slab": "purpur-flise",
  "block.minecraft.prismarine_slab": "prismarine-flise",
  "block.minecraft.prismarine_brick_slab": "prismarine-murstensflise",
  "block.minecraft.dark_prismarine_slab": "mørk prismarine-flise",
  "block.minecraft.smooth_quartz": "glat kvartsblok",
  "block.minecraft.smooth_red_sandstone": "glat rød sandsten",
  "block.minecraft.smooth_sandstone": "glat sandsten",
  "block.minecraft.smooth_stone": "glat sten",
  "block.minecraft.bricks": "mursten",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bogreol",
  "block.minecraft.mossy_cobblestone": "mosbegroede brosten",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fakkel",
  "block.minecraft.end_rod": "ender stang",
  "block.minecraft.chorus_plant": "omkvædsplante",
  "block.minecraft.chorus_flower": "omkvædsblomst",
  "block.minecraft.purpur_block": "purpur blok",
  "block.minecraft.purpur_pillar": "purpur søjle",
  "block.minecraft.purpur_stairs": "purpur trappe",
  "block.minecraft.spawner": "fremkalder",
  "block.minecraft.oak_stairs": "egetrappe",
  "block.minecraft.chest": "kiste",
  "block.minecraft.diamond_ore": "diamantmalm",
  "block.minecraft.diamond_block": "blok af diamant",
  "block.minecraft.crafting_table": "arbejdsbord",
  "block.minecraft.farmland": "landbrugsjord",
  "block.minecraft.furnace": "ovn",
  "block.minecraft.ladder": "stige",
  "block.minecraft.rail": "spor",
  "block.minecraft.cobblestone_stairs": "brostenstrappe",
  "block.minecraft.lever": "håndtag",
  "block.minecraft.stone_pressure_plate": "sten trykplade",
  "block.minecraft.oak_pressure_plate": "egetrykplade",
  "block.minecraft.spruce_pressure_plate": "grantrykplade",
  "block.minecraft.birch_pressure_plate": "birketrykplade",
  "block.minecraft.jungle_pressure_plate": "jungletrykplade",
  "block.minecraft.acacia_pressure_plate": "akacietrykplade",
  "block.minecraft.dark_oak_pressure_plate": "mørk egetrykplade",
  "block.minecraft.crimson_pressure_plate": "karmoisintrykplade",
  "block.minecraft.warped_pressure_plate": "forskruet trykplade",
  "block.minecraft.polished_blackstone_pressure_plate": "poleret sortstenstrykplade",
  "block.minecraft.redstone_ore": "rødstensmalm",
  "block.minecraft.redstone_torch": "rødstensfakkel",
  "block.minecraft.snow": "sne",
  "block.minecraft.ice": "is",
  "block.minecraft.snow_block": "sneblok",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "ler",
  "block.minecraft.jukebox": "jukeboks",
  "block.minecraft.oak_fence": "egetræshegn",
  "block.minecraft.spruce_fence": "granhegn",
  "block.minecraft.birch_fence": "birkehegn",
  "block.minecraft.jungle_fence": "junglehegn",
  "block.minecraft.acacia_fence": "akaciehegn",
  "block.minecraft.dark_oak_fence": "mørk egetræshegn",
  "block.minecraft.crimson_fence": "karmoisinhegn",
  "block.minecraft.warped_fence": "forskruet hegn",
  "block.minecraft.pumpkin": "græskar",
  "block.minecraft.carved_pumpkin": "udskåret græskar",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sjælesand",
  "block.minecraft.soul_soil": "sjælejord",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "poleret basalt",
  "block.minecraft.soul_torch": "sjæleild fakkel",
  "block.minecraft.glowstone": "glødesten",
  "block.minecraft.jack_o_lantern": "græskar lanterne",
  "block.minecraft.oak_trapdoor": "egelem",
  "block.minecraft.spruce_trapdoor": "granlem",
  "block.minecraft.birch_trapdoor": "birkelem",
  "block.minecraft.jungle_trapdoor": "junglelem",
  "block.minecraft.acacia_trapdoor": "akacielem",
  "block.minecraft.dark_oak_trapdoor": "mørk egelem",
  "block.minecraft.crimson_trapdoor": "karmoisinlem",
  "block.minecraft.warped_trapdoor": "forskruet lem",
  "block.minecraft.infested_stone": "inficeret sten",
  "block.minecraft.infested_cobblestone": "inficeret brosten",
  "block.minecraft.infested_stone_bricks": "inficeret stenmursten",
  "block.minecraft.infested_mossy_stone_bricks": "inficeret mosbegroede stenmursten",
  "block.minecraft.infested_cracked_stone_bricks": "inficeret revnede stenmursten",
  "block.minecraft.infested_chiseled_stone_bricks": "inficeret mejslet stenmursten",
  "block.minecraft.stone_bricks": "stenmursten",
  "block.minecraft.mossy_stone_bricks": "mosbegroede stenmursten",
  "block.minecraft.cracked_stone_bricks": "revnede stenmursten",
  "block.minecraft.chiseled_stone_bricks": "mejslede stenmursten",
  "block.minecraft.brown_mushroom_block": "brun svampeblok",
  "block.minecraft.red_mushroom_block": "rød svampeblok",
  "block.minecraft.mushroom_stem": "svampestamme",
  "block.minecraft.iron_bars": "jerntremmer",
  "block.minecraft.chain": "kæde",
  "block.minecraft.glass_pane": "glaspanel",
  "block.minecraft.melon": "vandmelon",
  "block.minecraft.vine": "lianer",
  "block.minecraft.oak_fence_gate": "egetræshegnslåge",
  "block.minecraft.spruce_fence_gate": "granhegnslåge",
  "block.minecraft.birch_fence_gate": "birkehegnslåge",
  "block.minecraft.jungle_fence_gate": "junglehegnslåge",
  "block.minecraft.acacia_fence_gate": "akaciehegnslåge",
  "block.minecraft.dark_oak_fence_gate": "mørk egetræshegnslåge",
  "block.minecraft.crimson_fence_gate": "karmoisinhegnslåge",
  "block.minecraft.warped_fence_gate": "forskruet hegnslåge",
  "block.minecraft.brick_stairs": "murstenstrappe",
  "block.minecraft.stone_brick_stairs": "stenmurstenstrappe",
  "block.minecraft.mycelium": "svampevæv",
  "block.minecraft.lily_pad": "åkande",
  "block.minecraft.nether_bricks": "nethermursten",
  "block.minecraft.cracked_nether_bricks": "revnede nether-mursten",
  "block.minecraft.chiseled_nether_bricks": "mejslet nether-mursten",
  "block.minecraft.nether_brick_fence": "nether-murstenshegn",
  "block.minecraft.nether_brick_stairs": "nether-murstenstrappe",
  "block.minecraft.enchanting_table": "fortryllelsesbord",
  "block.minecraft.end_portal_frame": "end portalramme",
  "block.minecraft.end_stone": "end-sten",
  "block.minecraft.end_stone_bricks": "end-mursten",
  "block.minecraft.dragon_egg": "drageæg",
  "block.minecraft.redstone_lamp": "rødstenslampe",
  "block.minecraft.sandstone_stairs": "sandstenstrappe",
  "block.minecraft.emerald_ore": "smaragdmalm",
  "block.minecraft.ender_chest": "enderkiste",
  "block.minecraft.tripwire_hook": "snubletrådskrog",
  "block.minecraft.emerald_block": "blok af smaragd",
  "block.minecraft.spruce_stairs": "grantrappe",
  "block.minecraft.birch_stairs": "birketrappe",
  "block.minecraft.jungle_stairs": "jungletrappe",
  "block.minecraft.crimson_stairs": "karmoisintrappe",
  "block.minecraft.warped_stairs": "forskruet trappe",
  "block.minecraft.command_block": "kommandoblok",
  "block.minecraft.beacon": "signallys",
  "block.minecraft.cobblestone_wall": "brostensvæg",
  "block.minecraft.mossy_cobblestone_wall": "mosbegroet brostensvæg",
  "block.minecraft.brick_wall": "murstensvæg",
  "block.minecraft.prismarine_wall": "prismarine-væg",
  "block.minecraft.red_sandstone_wall": "rød sandstensvæg",
  "block.minecraft.mossy_stone_brick_wall": "mosbegroet stenmurstensvæg",
  "block.minecraft.granite_wall": "granitvæg",
  "block.minecraft.stone_brick_wall": "stenmurstensvæg",
  "block.minecraft.nether_brick_wall": "nether-murstensvæg",
  "block.minecraft.andesite_wall": "andesitvæg",
  "block.minecraft.red_nether_brick_wall": "rød nether-murstensvæg",
  "block.minecraft.sandstone_wall": "sandstensvæg",
  "block.minecraft.end_stone_brick_wall": "end-murstensvæg",
  "block.minecraft.diorite_wall": "dioritvæg",
  "block.minecraft.blackstone_wall": "sortstensvæg",
  "block.minecraft.polished_blackstone_wall": "poleret sortsten-væg",
  "block.minecraft.polished_blackstone_brick_wall": "poleret sortsten-murstensvæg",
  "block.minecraft.stone_button": "stenknap",
  "block.minecraft.oak_button": "egeknap",
  "block.minecraft.spruce_button": "granknap",
  "block.minecraft.birch_button": "birkeknap",
  "block.minecraft.jungle_button": "jungleknap",
  "block.minecraft.acacia_button": "akacieknap",
  "block.minecraft.dark_oak_button": "mørk egeknap",
  "block.minecraft.crimson_button": "karmoisinknap",
  "block.minecraft.warped_button": "forskruet knap",
  "block.minecraft.polished_blackstone_button": "poleret sortsten-knap",
  "block.minecraft.anvil": "ambolt",
  "block.minecraft.chipped_anvil": "hakket ambolt",
  "block.minecraft.damaged_anvil": "beskadet ambolt",
  "block.minecraft.trapped_chest": "fældekiste",
  "block.minecraft.light_weighted_pressure_plate": "letvægtet trykplade",
  "block.minecraft.heavy_weighted_pressure_plate": "tungvægtet trykplade",
  "block.minecraft.daylight_detector": "dagslysdetektor",
  "block.minecraft.redstone_block": "blok af rødsten",
  "block.minecraft.nether_quartz_ore": "nether-kvartsmalm",
  "block.minecraft.hopper": "tragt",
  "block.minecraft.chiseled_quartz_block": "mejslet kvarts blok",
  "block.minecraft.quartz_block": "blok af kvarts",
  "block.minecraft.quartz_bricks": "kvartsmursten",
  "block.minecraft.quartz_pillar": "kvartssøjle",
  "block.minecraft.quartz_stairs": "kvartstrappe",
  "block.minecraft.activator_rail": "aktiveringsspor",
  "block.minecraft.dropper": "udkaster",
  "block.minecraft.white_terracotta": "hvid terrakotta",
  "block.minecraft.orange_terracotta": "orange terrakotta",
  "block.minecraft.magenta_terracotta": "lyslilla terrakotta",
  "block.minecraft.light_blue_terracotta": "lyseblå terrakotta",
  "block.minecraft.yellow_terracotta": "gul terrakotta",
  "block.minecraft.lime_terracotta": "limegrøn terrakotta",
  "block.minecraft.pink_terracotta": "lyserød terrakotta",
  "block.minecraft.gray_terracotta": "grå terrakotta",
  "block.minecraft.light_gray_terracotta": "lysegrå terrakotta",
  "block.minecraft.cyan_terracotta": "turkis terrakotta",
  "block.minecraft.purple_terracotta": "lilla terrakotta",
  "block.minecraft.blue_terracotta": "blå terrakotta",
  "block.minecraft.brown_terracotta": "brun terrakotta",
  "block.minecraft.green_terracotta": "grøn terrakotta",
  "block.minecraft.red_terracotta": "rød terrakotta",
  "block.minecraft.black_terracotta": "sort terrakotta",
  "block.minecraft.barrier": "barriere",
  "block.minecraft.iron_trapdoor": "jernlem",
  "block.minecraft.hay_block": "halmballe",
  "block.minecraft.white_carpet": "hvidt tæppe",
  "block.minecraft.orange_carpet": "orange tæppe",
  "block.minecraft.magenta_carpet": "lyslilla tæppe",
  "block.minecraft.light_blue_carpet": "lyseblåt tæppe",
  "block.minecraft.yellow_carpet": "gult tæppe",
  "block.minecraft.lime_carpet": "limegrønt tæppe",
  "block.minecraft.pink_carpet": "lyserødt tæppe",
  "block.minecraft.gray_carpet": "gråt tæppe",
  "block.minecraft.light_gray_carpet": "lysegråt tæppe",
  "block.minecraft.cyan_carpet": "turkis tæppe",
  "block.minecraft.purple_carpet": "lilla tæppe",
  "block.minecraft.blue_carpet": "blåt tæppe",
  "block.minecraft.brown_carpet": "brunt tæppe",
  "block.minecraft.green_carpet": "grønt tæppe",
  "block.minecraft.red_carpet": "rødt tæppe",
  "block.minecraft.black_carpet": "sort tæppe",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "blok af kul",
  "block.minecraft.packed_ice": "sammenpresset is",
  "block.minecraft.acacia_stairs": "akacietrappe",
  "block.minecraft.dark_oak_stairs": "mørke egetrappe",
  "block.minecraft.slime_block": "slim blok",
  "block.minecraft.grass_path": "græs sti",
  "block.minecraft.sunflower": "solsikke",
  "block.minecraft.lilac": "syren",
  "block.minecraft.rose_bush": "rosenbusk",
  "block.minecraft.peony": "pæon",
  "block.minecraft.tall_grass": "højt græs",
  "block.minecraft.large_fern": "stor bregne",
  "block.minecraft.white_stained_glass": "hvidt farvet glas",
  "block.minecraft.orange_stained_glass": "orange farvet glas",
  "block.minecraft.magenta_stained_glass": "lyslilla farvet glas",
  "block.minecraft.light_blue_stained_glass": "lyseblåt farvet glas",
  "block.minecraft.yellow_stained_glass": "gult farvet glas",
  "block.minecraft.lime_stained_glass": "limegrønt farvet glas",
  "block.minecraft.pink_stained_glass": "lyserødt farvet glas",
  "block.minecraft.gray_stained_glass": "gråt farvet glas",
  "block.minecraft.light_gray_stained_glass": "lysegråt farvet glas",
  "block.minecraft.cyan_stained_glass": "turkis farvet glas",
  "block.minecraft.purple_stained_glass": "lilla farvet glas",
  "block.minecraft.blue_stained_glass": "blåt farvet glas",
  "block.minecraft.brown_stained_glass": "brunt farvet glas",
  "block.minecraft.green_stained_glass": "grønt farvet glas",
  "block.minecraft.red_stained_glass": "rødt farvet glas",
  "block.minecraft.black_stained_glass": "sort farvet glas",
  "block.minecraft.white_stained_glass_pane": "hvidt farvet glaspanel",
  "block.minecraft.orange_stained_glass_pane": "orange farvet glaspanel",
  "block.minecraft.magenta_stained_glass_pane": "lyslilla farvet glaspanel",
  "block.minecraft.light_blue_stained_glass_pane": "lyseblåt farvet glaspanel",
  "block.minecraft.yellow_stained_glass_pane": "gult farvet glaspanel",
  "block.minecraft.lime_stained_glass_pane": "limegrønt farvet glaspanel",
  "block.minecraft.pink_stained_glass_pane": "lyserødt farvet glaspanel",
  "block.minecraft.gray_stained_glass_pane": "gråt farvet glaspanel",
  "block.minecraft.light_gray_stained_glass_pane": "lysegråt farvet glaspanel",
  "block.minecraft.cyan_stained_glass_pane": "turkis farvet glaspanel",
  "block.minecraft.purple_stained_glass_pane": "lilla farvet glaspanel",
  "block.minecraft.blue_stained_glass_pane": "blåt farvet glaspanel",
  "block.minecraft.brown_stained_glass_pane": "brunt farvet glaspanel",
  "block.minecraft.green_stained_glass_pane": "grønt farvet glaspanel",
  "block.minecraft.red_stained_glass_pane": "rødt farvet glaspanel",
  "block.minecraft.black_stained_glass_pane": "sort farvet glaspanel",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarine mursten",
  "block.minecraft.dark_prismarine": "mørk prismarine",
  "block.minecraft.prismarine_stairs": "prismarine-trappe",
  "block.minecraft.prismarine_brick_stairs": "prismarine-murstenstrappe",
  "block.minecraft.dark_prismarine_stairs": "mørk prismarine-trappe",
  "block.minecraft.sea_lantern": "sølanterne",
  "block.minecraft.red_sandstone": "rød sandsten",
  "block.minecraft.chiseled_red_sandstone": "mejslet rød sandsten",
  "block.minecraft.cut_red_sandstone": "skåret rød sandsten",
  "block.minecraft.red_sandstone_stairs": "rød sandstenstrappe",
  "block.minecraft.repeating_command_block": "gentagende kommandoblok",
  "block.minecraft.chain_command_block": "kæde kommandoblok",
  "block.minecraft.magma_block": "magmablok",
  "block.minecraft.nether_wart_block": "nether-vorteblok",
  "block.minecraft.warped_wart_block": "forskruet nether-vorteblok",
  "block.minecraft.red_nether_bricks": "røde nether-mursten",
  "block.minecraft.bone_block": "ben blok",
  "block.minecraft.structure_void": "struktur-tomrum",
  "block.minecraft.observer": "observatør",
  "block.minecraft.shulker_box": "shulker boks",
  "block.minecraft.white_shulker_box": "hvid shulker boks",
  "block.minecraft.orange_shulker_box": "orange shulker boks",
  "block.minecraft.magenta_shulker_box": "lyslilla shulker boks",
  "block.minecraft.light_blue_shulker_box": "lysseblå shulker boks",
  "block.minecraft.yellow_shulker_box": "gul shulker boks",
  "block.minecraft.lime_shulker_box": "limegrøn shulker boks",
  "block.minecraft.pink_shulker_box": "lyserød shulker boks",
  "block.minecraft.gray_shulker_box": "grå shulker boks",
  "block.minecraft.light_gray_shulker_box": "lyssegrå shulker boks",
  "block.minecraft.cyan_shulker_box": "turkis shulker boks",
  "block.minecraft.purple_shulker_box": "lilla shulker boks",
  "block.minecraft.blue_shulker_box": "blå shulker boks",
  "block.minecraft.brown_shulker_box": "brun shulker boks",
  "block.minecraft.green_shulker_box": "grøn shulker boks",
  "block.minecraft.red_shulker_box": "rød shulker boks",
  "block.minecraft.black_shulker_box": "sort shulker boks",
  "block.minecraft.white_glazed_terracotta": "hvid glaseret terrakotta",
  "block.minecraft.orange_glazed_terracotta": "orange glaseret terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "lyslilla glaseret terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "lyseblå glaseret terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "gul glaseret terrakotta",
  "block.minecraft.lime_glazed_terracotta": "limegrøn glaseret terrakotta",
  "block.minecraft.pink_glazed_terracotta": "lyserød glaseret terrakotta",
  "block.minecraft.gray_glazed_terracotta": "grå glaseret terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "lysegrå glaseret terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "turkis glaseret terrakotta",
  "block.minecraft.purple_glazed_terracotta": "lilla glaseret terrakotta",
  "block.minecraft.blue_glazed_terracotta": "blå glaseret terrakotta",
  "block.minecraft.brown_glazed_terracotta": "brun glaseret terrakotta",
  "block.minecraft.green_glazed_terracotta": "grøn glaseret terrakotta",
  "block.minecraft.red_glazed_terracotta": "rød glaseret terrakotta",
  "block.minecraft.black_glazed_terracotta": "sort glaseret terrakotta",
  "block.minecraft.white_concrete": "hvid beton",
  "block.minecraft.orange_concrete": "orange beton",
  "block.minecraft.magenta_concrete": "lyslilla beton",
  "block.minecraft.light_blue_concrete": "lyseblå beton",
  "block.minecraft.yellow_concrete": "gul beton",
  "block.minecraft.lime_concrete": "limegrøn beton",
  "block.minecraft.pink_concrete": "lyserød beton",
  "block.minecraft.gray_concrete": "grå beton",
  "block.minecraft.light_gray_concrete": "lysegrå beton",
  "block.minecraft.cyan_concrete": "turkis beton",
  "block.minecraft.purple_concrete": "lilla beton",
  "block.minecraft.blue_concrete": "blå beton",
  "block.minecraft.brown_concrete": "brun beton",
  "block.minecraft.green_concrete": "grøn beton",
  "block.minecraft.red_concrete": "rød beton",
  "block.minecraft.black_concrete": "sort beton",
  "block.minecraft.white_concrete_powder": "hvidt beton pulver",
  "block.minecraft.orange_concrete_powder": "orange beton pulver",
  "block.minecraft.magenta_concrete_powder": "lyslilla beton pulver",
  "block.minecraft.light_blue_concrete_powder": "lyseblåt beton pulver",
  "block.minecraft.yellow_concrete_powder": "gult beton pulver",
  "block.minecraft.lime_concrete_powder": "limegrønt beton pulver",
  "block.minecraft.pink_concrete_powder": "lyserødt beton pulver",
  "block.minecraft.gray_concrete_powder": "gråt beton pulver",
  "block.minecraft.light_gray_concrete_powder": "lysegråt beton pulver",
  "block.minecraft.cyan_concrete_powder": "turkis beton pulver",
  "block.minecraft.purple_concrete_powder": "lilla beton pulver",
  "block.minecraft.blue_concrete_powder": "blåt beton pulver",
  "block.minecraft.brown_concrete_powder": "brunt beton pulver",
  "block.minecraft.green_concrete_powder": "grønt beton pulver",
  "block.minecraft.red_concrete_powder": "rødt beton pulver",
  "block.minecraft.black_concrete_powder": "sort beton pulver",
  "block.minecraft.turtle_egg": "skildpaddeæg",
  "block.minecraft.dead_tube_coral_block": "død orgelkoralblok",
  "block.minecraft.dead_brain_coral_block": "død hjernekoralblok",
  "block.minecraft.dead_bubble_coral_block": "død boblekoralblok",
  "block.minecraft.dead_fire_coral_block": "død ildkoralblok",
  "block.minecraft.dead_horn_coral_block": "død hornkoralblok",
  "block.minecraft.tube_coral_block": "orgelkoralblok",
  "block.minecraft.brain_coral_block": "hjernekoralblok",
  "block.minecraft.bubble_coral_block": "boblekoralblok",
  "block.minecraft.fire_coral_block": "ildkoralblok",
  "block.minecraft.horn_coral_block": "hornkoralblok",
  "block.minecraft.tube_coral": "orgelkoral",
  "block.minecraft.brain_coral": "hjernekoral",
  "block.minecraft.bubble_coral": "boblekoral",
  "block.minecraft.fire_coral": "ildkoral",
  "block.minecraft.horn_coral": "hornkoral",
  "block.minecraft.dead_brain_coral": "død hjernekoral",
  "block.minecraft.dead_bubble_coral": "død boblekoral",
  "block.minecraft.dead_fire_coral": "død ildkoral",
  "block.minecraft.dead_horn_coral": "død hornkoral",
  "block.minecraft.dead_tube_coral": "død orgelkoral",
  "block.minecraft.tube_coral_fan": "orgelkoralvifte",
  "block.minecraft.brain_coral_fan": "hjernekoralvifte",
  "block.minecraft.bubble_coral_fan": "boblekoralvifte",
  "block.minecraft.fire_coral_fan": "ildkoralvifte",
  "block.minecraft.horn_coral_fan": "hornkoralvifte",
  "block.minecraft.dead_tube_coral_fan": "død orgelkoralvifte",
  "block.minecraft.dead_brain_coral_fan": "død hjernekoralvifte",
  "block.minecraft.dead_bubble_coral_fan": "død boblekoralvifte",
  "block.minecraft.dead_fire_coral_fan": "død ildkoralvifte",
  "block.minecraft.dead_horn_coral_fan": "død hornkoralvifte",
  "block.minecraft.blue_ice": "blåis",
  "block.minecraft.conduit": "fløder",
  "block.minecraft.polished_granite_stairs": "poleret granittrappe",
  "block.minecraft.smooth_red_sandstone_stairs": "glat rød sandstenstrappe",
  "block.minecraft.mossy_stone_brick_stairs": "mosbegroet stenmurstenstrappe",
  "block.minecraft.polished_diorite_stairs": "poleret diorittrappe",
  "block.minecraft.mossy_cobblestone_stairs": "mosbegroet brostenstrappe",
  "block.minecraft.end_stone_brick_stairs": "end-murstenstrapper",
  "block.minecraft.stone_stairs": "stentrappe",
  "block.minecraft.smooth_sandstone_stairs": "glat sandstenstrappe",
  "block.minecraft.smooth_quartz_stairs": "glat kvartstrappe",
  "block.minecraft.granite_stairs": "granittrappe",
  "block.minecraft.andesite_stairs": "andesittrappe",
  "block.minecraft.red_nether_brick_stairs": "rød nether-murstenstrappe",
  "block.minecraft.polished_andesite_stairs": "poleret andesittrappe",
  "block.minecraft.diorite_stairs": "diorittrappe",
  "block.minecraft.polished_granite_slab": "poleret granitflise",
  "block.minecraft.smooth_red_sandstone_slab": "glat rød sandstensflise",
  "block.minecraft.mossy_stone_brick_slab": "mosbegroet stenmurstensflise",
  "block.minecraft.polished_diorite_slab": "poleret dioritflise",
  "block.minecraft.mossy_cobblestone_slab": "mosbegroet brostensflise",
  "block.minecraft.end_stone_brick_slab": "end-murstensflise",
  "block.minecraft.smooth_sandstone_slab": "glat sandstensflise",
  "block.minecraft.smooth_quartz_slab": "glat kvartsflise",
  "block.minecraft.granite_slab": "granitflise",
  "block.minecraft.andesite_slab": "andesitflise",
  "block.minecraft.red_nether_brick_slab": "rød nether-murstensflise",
  "block.minecraft.polished_andesite_slab": "poleret andesitflise",
  "block.minecraft.diorite_slab": "dioritflise",
  "block.minecraft.scaffolding": "stillads",
  "block.minecraft.iron_door": "jerndør",
  "block.minecraft.oak_door": "egetræsdør",
  "block.minecraft.spruce_door": "grandør",
  "block.minecraft.birch_door": "birkedør",
  "block.minecraft.jungle_door": "jungledør",
  "block.minecraft.acacia_door": "akaciedør",
  "block.minecraft.dark_oak_door": "mørk egetræsdør",
  "block.minecraft.crimson_door": "karmoisindør",
  "block.minecraft.warped_door": "forskruet dør",
  "block.minecraft.repeater": "rødstens-gentager",
  "block.minecraft.comparator": "rødstens-komparator",
  "block.minecraft.structure_block": "strukturblok",
  "block.minecraft.jigsaw": "puslespils blok",
  "item.minecraft.turtle_helmet": "skildpaddeskjold□□når på hovedet:□+2 beskyttelse",
  "item.minecraft.scute": "skildpaddeskjold",
  "item.minecraft.iron_shovel": "jernspade□□når i primære hånd:□+3.5 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.iron_pickaxe": "jernhakke□□når i primære hånd:□+3 angrebsstyrke□-2.8 angrebshastighed",
  "item.minecraft.iron_axe": "jernøkse□□når i primære hånd:□+8 angrebsstyrke□-3.1 angrebshastighed",
  "item.minecraft.flint_and_steel": "flint og stål",
  "item.minecraft.apple": "æble",
  "item.minecraft.bow": "bue",
  "item.minecraft.arrow": "pil",
  "item.minecraft.coal": "kul",
  "item.minecraft.charcoal": "trækul",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "jernbarre",
  "item.minecraft.gold_ingot": "guldbarre",
  "item.minecraft.netherite_ingot": "netherritbarre",
  "item.minecraft.netherite_scrap": "netherittskrot",
  "item.minecraft.iron_sword": "jernsværd□□når i primære hånd:□+5 angrebsstyrke□-2.4 angrebshastighed",
  "item.minecraft.wooden_sword": "træsværd□□når i primære hånd:□+3 angrebsstyrke□-2.4 angrebshastighed",
  "item.minecraft.wooden_shovel": "træspade□□når i primære hånd:□+1.5 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.wooden_pickaxe": "træhakke□□når i primære hånd:□+1 angrebsstyrke□-2.8 angrebshastighed",
  "item.minecraft.wooden_axe": "træøkse□□når i primære hånd:□+6 angrebsstyrke□-3.2 angrebshastighed",
  "item.minecraft.stone_sword": "stensværd□□når i primære hånd:□+4 angrebsstyrke□-2.4 angrebshastighed",
  "item.minecraft.stone_shovel": "stenspade□□når i primære hånd:□+2.5 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.stone_pickaxe": "stenhakke□□når i primære hånd:□+2 angrebsstyrke□-2.8 angrebshastighed",
  "item.minecraft.stone_axe": "stenøkse□□når i primære hånd:□+8 angrebsstyrke□-3.2 angrebshastighed",
  "item.minecraft.diamond_sword": "diamantsværd□□når i primære hånd:□+6 angrebsstyrke□-2.4 angrebshastighed",
  "item.minecraft.diamond_shovel": "diamantspade□□når i primære hånd:□+4.5 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.diamond_pickaxe": "diamanthakke□□når i primære hånd:□+4 angrebsstyrke□-2.8 angrebshastighed",
  "item.minecraft.diamond_axe": "diamantøkse□□når i primære hånd:□+8 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.stick": "pind",
  "item.minecraft.bowl": "skål",
  "item.minecraft.mushroom_stew": "svampestuvning",
  "item.minecraft.golden_sword": "guldsværd□□når i primære hånd:□+3 angrebsstyrke□-2.4 angrebshastighed",
  "item.minecraft.golden_shovel": "guldspade□□når i primære hånd:□+1.5 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.golden_pickaxe": "guldhakke□□når i primære hånd:□+1 angrebsstyrke□-2.8 angrebshastighed",
  "item.minecraft.golden_axe": "guldøkse□□når i primære hånd:□+6 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.netherite_sword": "netherritsværd□□når i primære hånd:□+7 angrebsstyrke□-2.4 angrebshastighed",
  "item.minecraft.netherite_shovel": "netherritspade□□når i primære hånd:□+5.5 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.netherite_pickaxe": "netherrithakke□□når i primære hånd:□+5 angrebsstyrke□-2.8 angrebshastighed",
  "item.minecraft.netherite_axe": "netherritøkse□□når i primære hånd:□+9 angrebsstyrke□-3 angrebshastighed",
  "item.minecraft.string": "tråd",
  "item.minecraft.feather": "fjer",
  "item.minecraft.gunpowder": "krudt",
  "item.minecraft.wooden_hoe": "trælugejern□□når i primære hånd:□-3 angrebshastighed",
  "item.minecraft.stone_hoe": "stenlugejern□□når i primære hånd:□-2 angrebshastighed",
  "item.minecraft.iron_hoe": "jernlugejern□□når i primære hånd:□-1 angrebshastighed",
  "item.minecraft.diamond_hoe": "diamantlugejern□□når i primære hånd:",
  "item.minecraft.golden_hoe": "guldlugejern□□når i primære hånd:□-3 angrebshastighed",
  "item.minecraft.netherite_hoe": "netherritlugejern□□når i primære hånd:",
  "item.minecraft.wheat_seeds": "hvede frø",
  "item.minecraft.wheat": "hvede",
  "item.minecraft.bread": "brød",
  "item.minecraft.leather_helmet": "læderhat□□når på hovedet:□+1 beskyttelse",
  "item.minecraft.leather_chestplate": "lædertunika□□når på kroppen:□+3 beskyttelse",
  "item.minecraft.leather_leggings": "læderbukser□□når på benene:□+2 beskyttelse",
  "item.minecraft.leather_boots": "læderstøvler□□når på fødderne:□+1 beskyttelse",
  "item.minecraft.chainmail_helmet": "brynjehjelm□□når på hovedet:□+2 beskyttelse",
  "item.minecraft.chainmail_chestplate": "brynjebrystplade□□når på kroppen:□+5 beskyttelse",
  "item.minecraft.chainmail_leggings": "brynjebukser□□når på benene:□+4 beskyttelse",
  "item.minecraft.chainmail_boots": "brynjestøvler□□når på fødderne:□+1 beskyttelse",
  "item.minecraft.iron_helmet": "jernhjelm□□når på hovedet:□+2 beskyttelse",
  "item.minecraft.iron_chestplate": "jernbrystplade□□når på kroppen:□+6 beskyttelse",
  "item.minecraft.iron_leggings": "jernbukser□□når på benene:□+5 beskyttelse",
  "item.minecraft.iron_boots": "jernstøvler□□når på fødderne:□+2 beskyttelse",
  "item.minecraft.diamond_helmet": "diamanthjelm□□når på hovedet:□+3 beskyttelse□+2 rustnings hårdhed",
  "item.minecraft.diamond_chestplate": "diamantbrystplade□□når på kroppen:□+8 beskyttelse□+2 rustnings hårdhed",
  "item.minecraft.diamond_leggings": "diamantbukser□□når på benene:□+6 beskyttelse□+2 rustnings hårdhed",
  "item.minecraft.diamond_boots": "diamantstøvler□□når på fødderne:□+3 beskyttelse□+2 rustnings hårdhed",
  "item.minecraft.golden_helmet": "guldhjelm□□når på hovedet:□+2 beskyttelse",
  "item.minecraft.golden_chestplate": "guldbrystplade□□når på kroppen:□+5 beskyttelse",
  "item.minecraft.golden_leggings": "guldbukser□□når på benene:□+3 beskyttelse",
  "item.minecraft.golden_boots": "guldstøvler□□når på fødderne:□+1 beskyttelse",
  "item.minecraft.netherite_helmet": "netherrithjelm□□når på hovedet:□+3 beskyttelse□+3 rustnings hårdhed□+1 tilbageslagsbeskyttelse",
  "item.minecraft.netherite_chestplate": "netherritbrystplade□□når på kroppen:□+8 beskyttelse□+3 rustnings hårdhed□+1 tilbageslagsbeskyttelse",
  "item.minecraft.netherite_leggings": "netherritbukser□□når på benene:□+6 beskyttelse□+3 rustnings hårdhed□+1 tilbageslagsbeskyttelse",
  "item.minecraft.netherite_boots": "netherritstøvler□□når på fødderne:□+3 beskyttelse□+3 rustnings hårdhed□+1 tilbageslagsbeskyttelse",
  "item.minecraft.flint": "flint",
  "item.minecraft.porkchop": "rå svinekotelet",
  "item.minecraft.cooked_porkchop": "stegt svinekotelet",
  "item.minecraft.painting": "maleri",
  "item.minecraft.golden_apple": "gyldent æble",
  "item.minecraft.enchanted_golden_apple": "fortryllet gyldent æble",
  "block.minecraft.oak_sign": "egetræsskilt",
  "block.minecraft.spruce_sign": "grantræsskilt",
  "block.minecraft.birch_sign": "birketræsskilt",
  "block.minecraft.jungle_sign": "jungletræsskilt",
  "block.minecraft.acacia_sign": "akacietræsskilt",
  "block.minecraft.dark_oak_sign": "mørkt egetræsskilt",
  "block.minecraft.crimson_sign": "karmoisinskilt",
  "block.minecraft.warped_sign": "forskruet skilt",
  "item.minecraft.bucket": "spand",
  "item.minecraft.water_bucket": "vandspand",
  "item.minecraft.lava_bucket": "lavaspand",
  "item.minecraft.minecart": "minevogn",
  "item.minecraft.saddle": "sadel",
  "item.minecraft.redstone": "rødstenspulver",
  "item.minecraft.snowball": "snebold",
  "item.minecraft.oak_boat": "egetræsbåd",
  "item.minecraft.leather": "læder",
  "item.minecraft.milk_bucket": "mælkespand",
  "item.minecraft.pufferfish_bucket": "spand med kuglefisk",
  "item.minecraft.salmon_bucket": "spand med laks",
  "item.minecraft.cod_bucket": "spand med torsk",
  "item.minecraft.tropical_fish_bucket": "spand med tropisk fisk",
  "item.minecraft.brick": "mursten",
  "item.minecraft.clay_ball": "lerbold",
  "block.minecraft.dried_kelp_block": "tørret tangblok",
  "item.minecraft.paper": "papir",
  "item.minecraft.book": "bog",
  "item.minecraft.slime_ball": "slimbold",
  "item.minecraft.chest_minecart": "minevogn med kiste",
  "item.minecraft.furnace_minecart": "minevogn med ovn",
  "item.minecraft.egg": "æg",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "fiskestang",
  "item.minecraft.clock": "ur",
  "item.minecraft.glowstone_dust": "glødestenspulver",
  "item.minecraft.cod": "rå torsk",
  "item.minecraft.salmon": "rå laks",
  "item.minecraft.tropical_fish": "tropisk fisk",
  "item.minecraft.pufferfish": "kuglefisk",
  "item.minecraft.cooked_cod": "kogt torsk",
  "item.minecraft.cooked_salmon": "kogt laks",
  "item.minecraft.ink_sac": "blækpose",
  "item.minecraft.red_dye": "rødt farvestof",
  "item.minecraft.green_dye": "grønt farvestof",
  "item.minecraft.cocoa_beans": "kakaobønner",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "lilla farvestof",
  "item.minecraft.cyan_dye": "turkis farvestof",
  "item.minecraft.light_gray_dye": "lysegråt farvestof",
  "item.minecraft.gray_dye": "gråt farvestof",
  "item.minecraft.pink_dye": "lyserødt farvestof",
  "item.minecraft.lime_dye": "limegrønt farvestof",
  "item.minecraft.yellow_dye": "gult farvestof",
  "item.minecraft.light_blue_dye": "lyseblåt farvestof",
  "item.minecraft.magenta_dye": "lyslilla farvestof",
  "item.minecraft.orange_dye": "orange farvestof",
  "item.minecraft.bone_meal": "benmel",
  "item.minecraft.blue_dye": "blåt farvestof",
  "item.minecraft.brown_dye": "brunt farvestof",
  "item.minecraft.black_dye": "sort farvestof",
  "item.minecraft.white_dye": "hvidt farvestof",
  "item.minecraft.bone": "knogle",
  "item.minecraft.sugar": "sukker",
  "block.minecraft.cake": "kage",
  "block.minecraft.white_bed": "hvid seng",
  "block.minecraft.orange_bed": "orange seng",
  "block.minecraft.magenta_bed": "lyslilla seng",
  "block.minecraft.light_blue_bed": "lyseblå seng",
  "block.minecraft.yellow_bed": "gul seng",
  "block.minecraft.lime_bed": "limegrøn seng",
  "block.minecraft.pink_bed": "lyserød seng",
  "block.minecraft.gray_bed": "grå seng",
  "block.minecraft.light_gray_bed": "lysegrå seng",
  "block.minecraft.cyan_bed": "turkis seng",
  "block.minecraft.purple_bed": "lilla seng",
  "block.minecraft.blue_bed": "blå seng",
  "block.minecraft.brown_bed": "brun seng",
  "block.minecraft.green_bed": "grøn seng",
  "block.minecraft.red_bed": "rød seng",
  "block.minecraft.black_bed": "sort seng",
  "item.minecraft.cookie": "småkage",
  "item.minecraft.filled_map": "kort□#0",
  "item.minecraft.shears": "saks",
  "item.minecraft.melon_slice": "melonskive",
  "item.minecraft.dried_kelp": "tørret tang",
  "item.minecraft.pumpkin_seeds": "græskarfrø",
  "item.minecraft.melon_seeds": "vandmelonsfrø",
  "item.minecraft.beef": "rå bøf",
  "item.minecraft.cooked_beef": "bøf",
  "item.minecraft.chicken": "rå kylling",
  "item.minecraft.cooked_chicken": "stegt kylling",
  "item.minecraft.rotten_flesh": "råddent kød",
  "item.minecraft.ender_pearl": "ender-perle",
  "item.minecraft.blaze_rod": "blaze-stav",
  "item.minecraft.ghast_tear": "ghast-tåre",
  "item.minecraft.gold_nugget": "guldklump",
  "item.minecraft.nether_wart": "nether-vorte",
  "item.minecraft.potion": "ulavelig eliksir□ingen effekter",
  "item.minecraft.glass_bottle": "glasflaske",
  "item.minecraft.spider_eye": "edderkoppeøje",
  "item.minecraft.fermented_spider_eye": "fermenteret edderkoppeøje",
  "item.minecraft.blaze_powder": "blaze-pulver",
  "item.minecraft.magma_cream": "magmacreme",
  "block.minecraft.brewing_stand": "bryggestand",
  "block.minecraft.cauldron": "gryde",
  "item.minecraft.ender_eye": "ender-øje",
  "item.minecraft.glistering_melon_slice": "glitrende melonskive",
  "item.minecraft.bat_spawn_egg": "flagermus fremkaldningsæg",
  "item.minecraft.bee_spawn_egg": "bi fremkaldingsæg",
  "item.minecraft.blaze_spawn_egg": "blaze fremkaldningsæg",
  "item.minecraft.cat_spawn_egg": "kat fremkaldningsæg",
  "item.minecraft.cave_spider_spawn_egg": "huleedderkop fremkaldningsæg",
  "item.minecraft.chicken_spawn_egg": "kylling fremkaldningsæg",
  "item.minecraft.cod_spawn_egg": "torsk fremkaldningsæg",
  "item.minecraft.cow_spawn_egg": "ko fremkaldningsæg",
  "item.minecraft.creeper_spawn_egg": "creeper fremkaldningsæg",
  "item.minecraft.dolphin_spawn_egg": "delfin fremkaldningsæg",
  "item.minecraft.donkey_spawn_egg": "æsel fremkaldningsæg",
  "item.minecraft.drowned_spawn_egg": "draug fremkaldningsæg",
  "item.minecraft.elder_guardian_spawn_egg": "gammel vogter fremkaldningsæg",
  "item.minecraft.enderman_spawn_egg": "enderman fremkaldningsæg",
  "item.minecraft.endermite_spawn_egg": "ender-mide fremkaldningsæg",
  "item.minecraft.evoker_spawn_egg": "fremkalder fremkaldningsæg",
  "item.minecraft.fox_spawn_egg": "ræv fremkaldningsæg",
  "item.minecraft.ghast_spawn_egg": "ghast fremkaldningsæg",
  "item.minecraft.guardian_spawn_egg": "vogter fremkaldningsæg",
  "item.minecraft.hoglin_spawn_egg": "hoglin fremkaldningsæg",
  "item.minecraft.horse_spawn_egg": "hest fremkaldningsæg",
  "item.minecraft.husk_spawn_egg": "udtørretskal fremkaldningsæg",
  "item.minecraft.llama_spawn_egg": "lama fremkaldningsæg",
  "item.minecraft.magma_cube_spawn_egg": "magmakube fremkaldningsæg",
  "item.minecraft.mooshroom_spawn_egg": "muhsvamp fremkaldningsæg",
  "item.minecraft.mule_spawn_egg": "muldyr fremkaldningsæg",
  "item.minecraft.ocelot_spawn_egg": "ozelot fremkaldningsæg",
  "item.minecraft.panda_spawn_egg": "panda fremkaldningsæg",
  "item.minecraft.parrot_spawn_egg": "papegøje fremkaldningsæg",
  "item.minecraft.phantom_spawn_egg": "fantom fremkaldningsæg",
  "item.minecraft.pig_spawn_egg": "gris fremkaldningsæg",
  "item.minecraft.piglin_spawn_egg": "piglin fremkaldningsæg",
  "item.minecraft.pillager_spawn_egg": "plyndrer fremkaldningsæg",
  "item.minecraft.polar_bear_spawn_egg": "isbjørn fremkaldningsæg",
  "item.minecraft.pufferfish_spawn_egg": "kuglefisk fremkaldningsæg",
  "item.minecraft.rabbit_spawn_egg": "kanin fremkaldningsæg",
  "item.minecraft.ravager_spawn_egg": "hærger fremkaldningsæg",
  "item.minecraft.salmon_spawn_egg": "laks fremkaldningsæg",
  "item.minecraft.sheep_spawn_egg": "får fremkaldningsæg",
  "item.minecraft.shulker_spawn_egg": "shulker fremkaldningsæg",
  "item.minecraft.silverfish_spawn_egg": "sølvfisk fremkaldningsæg",
  "item.minecraft.skeleton_spawn_egg": "skelet fremkaldningsæg",
  "item.minecraft.skeleton_horse_spawn_egg": "skelethest fremkaldningsæg",
  "item.minecraft.slime_spawn_egg": "slimklump fremkaldningsæg",
  "item.minecraft.spider_spawn_egg": "edderkop fremkaldningsæg",
  "item.minecraft.squid_spawn_egg": "blæksprutte fremkaldningsæg",
  "item.minecraft.stray_spawn_egg": "omstrejfer fremkaldningsæg",
  "item.minecraft.strider_spawn_egg": "lavavandrer fremkaldningsæg",
  "item.minecraft.trader_llama_spawn_egg": "forhandler lama fremkaldningsæg",
  "item.minecraft.tropical_fish_spawn_egg": "tropisk fisk fremkaldningsæg",
  "item.minecraft.turtle_spawn_egg": "skildpadde fremkaldningsæg",
  "item.minecraft.vex_spawn_egg": "vex fremkaldningsæg",
  "item.minecraft.villager_spawn_egg": "landsbyboer fremkaldningsæg",
  "item.minecraft.vindicator_spawn_egg": "hævner fremkaldningsæg",
  "item.minecraft.wandering_trader_spawn_egg": "handelsrejsende fremkaldningsæg",
  "item.minecraft.witch_spawn_egg": "heks fremkaldningsæg",
  "item.minecraft.wither_skeleton_spawn_egg": "wither-skelet fremkaldningsæg",
  "item.minecraft.wolf_spawn_egg": "ulv fremkaldningsæg",
  "item.minecraft.zoglin_spawn_egg": "zoglin fremkaldningsæg",
  "item.minecraft.zombie_spawn_egg": "zombie fremkaldningsæg",
  "item.minecraft.zombie_horse_spawn_egg": "zombiehest fremkaldningsæg",
  "item.minecraft.zombie_villager_spawn_egg": "zombie landsbyboer fremkaldningsæg",
  "item.minecraft.zombified_piglin_spawn_egg": "zombificeret piglin fremkaldningsæg",
  "item.minecraft.experience_bottle": "fortryllelsesflaske",
  "item.minecraft.fire_charge": "ildladning",
  "item.minecraft.writable_book": "bog og fjerpen",
  "item.minecraft.written_book": "skrevet bog",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "genstandsramme",
  "block.minecraft.flower_pot": "blomsterkrukke",
  "item.minecraft.carrot": "gulerod",
  "item.minecraft.potato": "kartoffel",
  "item.minecraft.baked_potato": "bagt kartoffel",
  "item.minecraft.poisonous_potato": "giftig kartoffel",
  "item.minecraft.map": "tomt kort",
  "item.minecraft.golden_carrot": "gylden gulerod",
  "block.minecraft.skeleton_skull": "kranium",
  "block.minecraft.wither_skeleton_skull": "witherskeletkranium",
  "block.minecraft.player_head": "spiller hoved",
  "block.minecraft.zombie_head": "zombiehoved",
  "block.minecraft.creeper_head": "creeper-hoved",
  "block.minecraft.dragon_head": "dragehoved",
  "item.minecraft.carrot_on_a_stick": "gulerod på en pind",
  "item.minecraft.warped_fungus_on_a_stick": "forskruet svamp på en pind",
  "item.minecraft.nether_star": "nether-stjerne",
  "item.minecraft.pumpkin_pie": "græskartærte",
  "item.minecraft.firework_rocket": "fyrværkeriraket",
  "item.minecraft.firework_star": "fyrværkeristjerne",
  "item.minecraft.enchanted_book": "fortryllet bog",
  "item.minecraft.nether_brick": "nether-mursten",
  "item.minecraft.quartz": "nether-kvarts",
  "item.minecraft.tnt_minecart": "minevogn med tnt",
  "item.minecraft.hopper_minecart": "minevogn med tragt",
  "item.minecraft.prismarine_shard": "prismarine-splint",
  "item.minecraft.prismarine_crystals": "prismarinekrystaller",
  "item.minecraft.rabbit": "rå kanin",
  "item.minecraft.cooked_rabbit": "kogt kanin",
  "item.minecraft.rabbit_stew": "kaninstuvning",
  "item.minecraft.rabbit_foot": "kaninfod",
  "item.minecraft.rabbit_hide": "kaninskind",
  "item.minecraft.armor_stand": "brynjeholder",
  "item.minecraft.iron_horse_armor": "jernhestearmering",
  "item.minecraft.golden_horse_armor": "guldhestearmering",
  "item.minecraft.diamond_horse_armor": "diamanthestearmering",
  "item.minecraft.leather_horse_armor": "læderhestearmering",
  "item.minecraft.lead": "snor",
  "item.minecraft.name_tag": "navneskilt",
  "item.minecraft.command_block_minecart": "minevogn med kommandoblok",
  "item.minecraft.mutton": "råt fårekød",
  "item.minecraft.cooked_mutton": "kogt fårekød",
  "block.minecraft.white_banner": "hvidt banner",
  "block.minecraft.orange_banner": "orange banner",
  "block.minecraft.magenta_banner": "lyslilla banner",
  "block.minecraft.light_blue_banner": "lyseblåt banner",
  "block.minecraft.yellow_banner": "gult banner",
  "block.minecraft.lime_banner": "limegrønt banner",
  "block.minecraft.pink_banner": "lyserødt banner",
  "block.minecraft.gray_banner": "gråt banner",
  "block.minecraft.light_gray_banner": "lysegråt banner",
  "block.minecraft.cyan_banner": "turkis banner",
  "block.minecraft.purple_banner": "lilla banner",
  "block.minecraft.blue_banner": "blåt banner",
  "block.minecraft.brown_banner": "brunt banner",
  "block.minecraft.green_banner": "grønt banner",
  "block.minecraft.red_banner": "rødt banner",
  "block.minecraft.black_banner": "sort banner",
  "item.minecraft.end_crystal": "end-krystal",
  "item.minecraft.chorus_fruit": "omkvædsfrugt",
  "item.minecraft.popped_chorus_fruit": "poppet omkvædsfrugt",
  "item.minecraft.beetroot": "rødbede",
  "item.minecraft.beetroot_seeds": "rødbedefrø",
  "item.minecraft.beetroot_soup": "rødbedesuppe",
  "item.minecraft.dragon_breath": "dragens ånde",
  "item.minecraft.splash_potion": "ulavelig sprøjtende eliksir□ingen effekter",
  "item.minecraft.spectral_arrow": "spektral pil",
  "item.minecraft.tipped_arrow": "ulavelig dyppet pil□ingen effekter",
  "item.minecraft.lingering_potion": "ulavelig hængende eliksir□ingen effekter",
  "item.minecraft.shield": "skjold",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "granbåd",
  "item.minecraft.birch_boat": "birkebåd",
  "item.minecraft.jungle_boat": "junglebåd",
  "item.minecraft.acacia_boat": "akaciebåd",
  "item.minecraft.dark_oak_boat": "mørk egetræsbåd",
  "item.minecraft.totem_of_undying": "totem af udødelighed",
  "item.minecraft.shulker_shell": "shulker skald",
  "item.minecraft.iron_nugget": "jernklump",
  "item.minecraft.knowledge_book": "kundskabsbog",
  "item.minecraft.debug_stick": "fejlfindingspind",
  "item.minecraft.music_disc_13": "musikplade□c418 - 13",
  "item.minecraft.music_disc_cat": "musikplade□c418 - cat",
  "item.minecraft.music_disc_blocks": "musikplade□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musikplade□c418 - chirp",
  "item.minecraft.music_disc_far": "musikplade□c418 - far",
  "item.minecraft.music_disc_mall": "musikplade□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musikplade□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musikplade□c418 - stal",
  "item.minecraft.music_disc_strad": "musikplade□c418 - strad",
  "item.minecraft.music_disc_ward": "musikplade□c418 - ward",
  "item.minecraft.music_disc_11": "musikplade□c418 - 11",
  "item.minecraft.music_disc_wait": "musikplade□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musikplade□lena raine - pigstep",
  "item.minecraft.trident": "trefork□□når i primære hånd:□+8 angrebsstyrke□-2.9 angrebshastighed",
  "item.minecraft.phantom_membrane": "fantommembran",
  "item.minecraft.nautilus_shell": "nautilskal",
  "item.minecraft.heart_of_the_sea": "havets hjerte",
  "item.minecraft.crossbow": "armbrøst",
  "item.minecraft.suspicious_stew": "mistænkelig stuvning",
  "block.minecraft.loom": "væv",
  "item.minecraft.flower_banner_pattern": "banner mønster□blomster symbol",
  "item.minecraft.creeper_banner_pattern": "banner mønster□creeper symbol",
  "item.minecraft.skull_banner_pattern": "banner mønster□kranium symbol",
  "item.minecraft.mojang_banner_pattern": "banner mønster□ting",
  "item.minecraft.globe_banner_pattern": "banner mønster□globus",
  "item.minecraft.piglin_banner_pattern": "banner mønster□snude",
  "block.minecraft.composter": "kompostbeholder",
  "block.minecraft.barrel": "tønde",
  "block.minecraft.smoker": "rygeovn",
  "block.minecraft.blast_furnace": "højovn",
  "block.minecraft.cartography_table": "kartografi bord",
  "block.minecraft.fletching_table": "pilemager bord",
  "block.minecraft.grindstone": "slibesten",
  "block.minecraft.lectern": "læsepult",
  "block.minecraft.smithing_table": "smedebord",
  "block.minecraft.stonecutter": "stenskærer",
  "block.minecraft.bell": "klokke",
  "block.minecraft.lantern": "lanterne",
  "block.minecraft.soul_lantern": "sjælelanterne",
  "item.minecraft.sweet_berries": "søde bær",
  "block.minecraft.campfire": "bål",
  "block.minecraft.soul_campfire": "sjælelejrbål",
  "block.minecraft.shroomlight": "svampelys",
  "item.minecraft.honeycomb": "bikage",
  "block.minecraft.bee_nest": "bikube",
  "block.minecraft.beehive": "bistade",
  "item.minecraft.honey_bottle": "honningflaske",
  "block.minecraft.honey_block": "honningblok",
  "block.minecraft.honeycomb_block": "bikageblok",
  "block.minecraft.lodestone": "ledesten",
  "block.minecraft.netherite_block": "blok af netherrit",
  "block.minecraft.ancient_debris": "ældgamle stumper",
  "block.minecraft.target": "mål",
  "block.minecraft.crying_obsidian": "grædende obsidian",
  "block.minecraft.blackstone": "sortsten",
  "block.minecraft.blackstone_slab": "sortstensflise",
  "block.minecraft.blackstone_stairs": "sortstenstrappe",
  "block.minecraft.gilded_blackstone": "forgyldt sortsten",
  "block.minecraft.polished_blackstone": "poleret sortsten",
  "block.minecraft.polished_blackstone_slab": "poleret sortstensflise",
  "block.minecraft.polished_blackstone_stairs": "poleret sortsten-trappe",
  "block.minecraft.chiseled_polished_blackstone": "mejslet poleret sortsten",
  "block.minecraft.polished_blackstone_bricks": "poleret sortsten-mursten",
  "block.minecraft.polished_blackstone_brick_slab": "poleret sortsten-murstensflise",
  "block.minecraft.polished_blackstone_brick_stairs": "poleret sortsten-murstenstrappe",
  "block.minecraft.cracked_polished_blackstone_bricks": "revnede poleret sortsten-mursten",
  "block.minecraft.respawn_anchor": "genoplivelsesanker",
}
export const da_dk = items; 
